import script from "./head.vue?vue&type=script&setup=true&lang=js"
export * from "./head.vue?vue&type=script&setup=true&lang=js"

import "./head.vue?vue&type=style&index=0&id=85db1d2c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85db1d2c"]])

export default __exports__